import { NavigateFunction } from "react-router-dom"
import { makeAutoObservable, reaction } from "mobx"

import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { widgetApi, widgetAppApi } from "@src/shared/api"
import {
  WidgetCreate,
  WidgetCurrencyResponse,
  WidgetResponse,
} from "@src/shared/api/generated"

type WidgetModifyInitReturn = {
  currencies?: (WidgetCurrencyResponse & { id: string })[]
  state: WidgetResponse
}

export class WidgetModifyStore {
  private _state: WidgetResponse = {} as WidgetResponse

  init = async (id: string): Promise<WidgetModifyInitReturn> => {
    await this.loadWidget(id)

    return {
      state: this._state,
    }
  }

  isLoading = false

  loadWidget = (id: string) => {
    this.isLoading = true

    return widgetApi
      .getWidget(id)
      .then(({ data: { data: response } }) => {
        if (response) {
          this._state = response
        }

        return response
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  modify = async (data: WidgetCreate) => {
    this.isLoading = true

    return (
      this.isNew
        ? widgetApi.createWidget(data)
        : widgetApi.updateWidget(this._state.id, data)
    )
      .then(() => {
        notify.success(this.isNew ? "Widget created" : "Widget updated")

        this.navigate(paths.widgets)
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  constructor(private navigate: NavigateFunction) {
    makeAutoObservable(this)
  }

  get isApproved() {
    return this._state.is_approved
  }

  get isNew() {
    return !this._state.id
  }

  get state() {
    return this._state
  }
}
